import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { ModelsTransformUtil } from '@ddt-web/common';
import { ComponentData } from '@ddt-web/data-service';
import { SharedApplicationConstants } from '@ddt-web/domain';

import { ModelListRow, ModelRowData } from '../../models';
import { ModelsExperienceFilters } from '../../models/dropdown-filters.interface';
import { ModelsBrowseFilterPipe } from '../../pipes/models-browse-filter.pipe';

@Component({
	selector: 'mb-portfolio-selection-cards-container',
	templateUrl: './portfolio-selection-cards-container.component.html',
	styleUrls: ['./portfolio-selection-cards-container.component.scss']
})
export class PortfolioSelectionCardsContainerComponent implements OnChanges {
	@Input() public data: ComponentData;
	@Input() public filter: ModelsExperienceFilters[];
	@Input() public selectedExploreCard: string;
	@Input() public selectedLeftNav: string;
	@Input() private selectedModelsToCompare: Array<ModelRowData> = [];
	@Input() private blkGroupModelsOnly: boolean = true;
	@Output() public readonly selectedModels: EventEmitter<ModelListRow> = new EventEmitter<ModelListRow>();

	public familyDataArr: Array<any> = [];
	public portfolioDataMap: Map<string, Array<ModelRowData>> = new Map<string, Array<ModelRowData>>();
	public selectedModelIds: Array<string> = [];

	constructor(private filterPipe: ModelsBrowseFilterPipe) { }

	public ngOnChanges(): void {
		this.familyDataArr = (this.data.getTabById('family.list')?.tableData?.[0] as any)?.rows ?? [];
		this.familyDataArr.forEach(item => {
			let portfolios = item.portfolios.formattedValue ?? [];
			if (this.blkGroupModelsOnly) {
				portfolios = portfolios.filter((data: any) => {
					const groups = data?.groups ?? [];
					const groupIdArray = groups.map(element => element.id);
					return groupIdArray.includes(SharedApplicationConstants.MODEL_FAMILY.BLACKROCK_FAMILY_GROUP);
				});
			}
			const portfolioDataForFamily = this.filterPipe.transform(portfolios, this.filter).map(data =>
				Object.assign({}, {
					modelId: data.id?.toString(),
					familyId: item.familyId?.formattedValue,
					dasModelOrder: data.dasModelOrder?.toString(),
					modelShortName: (data.managementType?.toString() === 'research' ? '*' : '') + data.shortName.toString(),
					riskProfile: data.riskProfile?.toString(),
					familyName: item.description?.formattedValue,
					exploreCardType: this.selectedExploreCard,
					leftNav: this.selectedLeftNav,
					dasPortfolioId: data.portfolioId?.toString()
				}));
			this.portfolioDataMap.set(item.familyId.formattedValue, ModelsTransformUtil.sortModelPortfolios(portfolioDataForFamily, 'dasModelOrder'));
		});
		this.selectedModelIds = this.selectedModelsToCompare.filter(item => item.checked).map(item => item?.modelId);
	}

}
